<template>
    <div class="container">
        <div style="background-image: url('../../../static/images/top_bg.png');width: 1920px;height: 82px;background-size: cover;">
            <div class="bi_title">
                德启全国产品实时动态
            </div>
            <!--            <div class="current_date">-->
            <!--                {{currentDate}}-->
            <!--            </div>-->
            <!--            <div class="current_year">-->
            <!--                {{currentYear}}-->
            <!--            </div>-->
            <!--            <div class="current_week">-->
            <!--                {{currentWeek}}-->
            <!--            </div>-->
        </div>


        <div style="float:left;position:absolute;z-index: 10;">
            <div class="bi_product">
                <div class="bi_product_add">
                    产品部署趋势
                </div>
            </div>

            <div id="product_arrange" :style="{width: '492px', height: '280px'}"></div>

            <div class="bi_device">
                <div class="bi_insert_device">
                    产品部署分布
                </div>
            </div>

            <div id="insert_device" :style="{width: '520px', height: '280px'}"></div>

            <div class="bi_data">
                <div class="bi_data_type">
                    产品使用趋势
                </div>
            </div>

            <div id="total_turnover" :style="{width: '492px', height: '280px'}"></div>
        </div>

        <div style="float: left;width: 883px;text-align: center;left: 515px;position: absolute;z-index: 10;"
             class="volume_statistics">
            <div style="margin-left: 13px;width: 870px;">
                <div class="arrange_area" style="float:left;">
                    <!--                    <div style="width: 49px;height: 49px;border-top: 2px solid #00A2FF;border-left: 2px solid #00A2FF;"></div>-->
                    <div class="arrange_area_number">
                        <countTo :startVal='past_arrange_area_number' :endVal='arrangeAreaNumber'
                                 :duration='3000'></countTo>
                    </div>
                    <div class="arrange_area_text">
                        累计部署量
                    </div>
                </div>

                <div class="device_roam" style="float:left;margin-left: 20px;">
                    <!--                    <div style="width: 49px;height: 49px;border-top: 2px solid #00A2FF;border-left: 2px solid #00A2FF;"></div>-->
                    <div class="device_roam_number">
                        <countTo :startVal='past_reverse_numbers' :endVal='reverseNumbers' :duration='3000'></countTo>
                    </div>
                    <div class="device_roam_text">
                        累计使用量
                    </div>
                </div>

                <div class="today_exception" style="float:left;margin-left: 20px;">
                    <!--                    <div style="width: 49px;height: 49px;border-top: 2px solid #00A2FF;border-left: 2px solid #00A2FF;"></div>-->
                    <div class="today_exception_number">
                        <countTo :startVal='past_today_reverse_exception_number' :endVal='todayReverseExceptionNumber'
                                 :duration='3000'></countTo>
                    </div>
                    <div class="today_exception_text">
                        剩余事件数
                    </div>
                </div>

                <div class="deal_event" style="float:left;margin-left: 20px;">
                    <!--                    <div style="width: 49px;height: 49px;border-top: 2px solid #00A2FF;border-left: 2px solid #00A2FF;"></div>-->
                    <div class="deal_event_number">
                        <countTo :startVal='past_deal_event_number' :endVal='dealEventNumber'
                                 :duration='3000'></countTo>
                    </div>
                    <div class="deal_event_text">
                        已处理事件数
                    </div>
                </div>
            </div>
            <!--            <div id="map" style="float: left;width: 883px;height: 687px;margin-top: 60px;"></div>-->
            <!--            -->

        </div>

        <!--        <img src="../../../static/images/reset.png" class="reSet" @click="reSet" id="reSet"/>-->
        <!--        <img src="../../../static/images/reset_click.png" class="reSet" id="reSetClick" style="display: none"/>-->

        <!-- 地图 -->
        <div id="map" style="position:absolute;width: 1920px;height: 1080px;top: 0;left: 0;"></div>

        <div style="float:left;position:absolute;left: 1413px;z-index: 10;">
            <div class="bi_court">
                <div class="bi_insert_court">
                    接入单位分布
                </div>
            </div>
            <div id="insert_court" :style="{width: '492px', height: '280px'}"></div>

            <div class="bi_product_type">
                <div class="bi_product_type_distribute">
                    产品类型分布
                </div>
            </div>
            <div id="product_type" :style="{width: '492px', height: '280px'}"></div>

            <div class="bi_exception">
                <div class="bi_exception_show">
                    事件一览
                </div>
            </div>

            <div style="display: flex;width: 492px;margin-top: 9px;margin-left: 2px;background: #0E468A;">
                <div style="margin-left: 41.5px;flex:0 0 25%" class="exception_title">
                    产品
                </div>
                <div class="exception_title" style="flex:0 0 40%">
                    发生地点
                </div>
                <div class="exception_title" style="flex: 1;">
                    发生时间
                </div>
            </div>

            <vue-seamless-scroll
                    class="seamless-warp" :data="exceptionList" :class-option="classOption"
                    v-if="exceptionList.length>9">
                <div style="display: flex;width: 492px;margin-top: 3px;height: 23px;background-color: rgba(33,193,255,0.12)"
                     v-for="(item,index) in exceptionList" :key="index" class="scroll">
                    <div style="margin-left: 41.5px;flex:0 0 25%" class="exception_content">
                        {{item.productName}}
                    </div>
                    <div class="exception_content" style="flex:0 0 40%">
                        {{item.apiCompanyName}}
                    </div>
                    <div class="exception_content" style="flex: 1;">
                        {{item.exceptionTime}}
                    </div>
                </div>
            </vue-seamless-scroll>

            <div v-else-if="exceptionList.length<10 && exceptionList.length>0" class="seamless-warp">
                <div style="display: flex;width: 492px;margin-top: 3px;height: 23px;background-color: rgba(33,193,255,0.12)"
                     v-for="(item,index) in exceptionList" :key="index" class="scroll">
                    <div style="margin-left: 41.5px;flex:0 0 25%" class="exception_content">
                        {{item.productName}}
                    </div>
                    <div class="exception_content" style="flex:0 0 40%">
                        {{item.apiCompanyName}}
                    </div>
                    <div class="exception_content" style="flex: 1;">
                        {{item.exceptionTime}}
                    </div>
                </div>
            </div>

            <div v-else
                 style="width: 492px;height: 220px;margin-left: 2px;color: white;background-color: rgba(33,193,255,0.12);text-align: center;line-height: 220px;box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);">
                暂无异常数据
            </div>
        </div>

    </div>
</template>

<script>
    import countTo from 'vue-count-to';
    import echarts from 'echarts';
    import china from 'echarts/map/json/china.json'
    import {selectAllYears, selectReverseYears,} from '@/api/center/hostinfo'
    import scroll from 'vue-seamless-scroll'
    import courtMap from '../../../static/js/courtMap'

    import {
        selectAllException,
        selectArrangeAreaNumber,
        selectDealEventNumber,
        selectdeployedDevicesTotalNumber,
        selectInsertCourt,
        selectInsertDevice,
        selectProductArrange,
        selectProductTypeSpread,
        selectReverseNumbers,
        selectTodayReverseExceptionNumber,
        selectTotalTurnover
    } from '@/api/center/statistical'
    import $ from "jquery";

    // echarts.registerMap('china', china)

    let target = new Map();
    let total = 0
    let insertDeviceXValueOffset = 0
    export default {
        components: {
            countTo,
            "vue-seamless-scroll": scroll
        },
        computed: {
            classOption() {
                return {
                    step: 0.4, //数值越大速度滚动越快
                    limitMoveNum: 10, //开始无缝滚动的数据量
                    hoverStop: true, //是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, //开启数据实时监控刷新dom
                    singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1000, //单步运动停止的时间(默认值1000ms)
                };
            },
        },
        data() {
            return {
                insertDeviceInterval: null,
                insertCourtInterval: null,
                maxHeight: 0,
                currentWeek: '',
                currentYear: '',
                currentDate: '',
                past_arrange_area_number: 0,
                past_reverse_numbers: 0,
                past_today_reverse_exception_number: 0,
                past_deal_event_number: 0,
                yearsList: [],
                exceptionList: [],
                productTypeSpreadList: [],
                productTypeNameList: [],
                productTypeData: {
                    value: '',
                    name: '',
                    itemStyle: {
                        color: ''
                    }
                },
                insertDeviceAreaList: [],
                insertDeviceNumList: [],
                arrangeAreaNumber: 0, // 总部署地区
                reverseNumbers: 0, // 总设备流转量
                todayReverseExceptionNumber: 0, // 今日异常数量
                dealEventNumber: 0, // 总处理事件
                insertDevice: {
                    title: {
                        text: '数量:  台',
                        x: '24px',//水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
                        y: '20px',
                        textStyle: {
                            fontFamily: 'Microsoft YaHei',
                            fontSize: 14,
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            color: '#FFFFFF',
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    dataZoom: [
                        {
                            type: 'inside',
                            zoomLock: true,
                            xAxisIndex: [0],
                            // left: '9%',
                            // bottom: -5,
                            startValue: 0,
                            endValue: 8 //初始化滚动条
                        }
                        // {
                        //     type: 'inside',
                        //     zoomLock: true,  // 设置为 true 只能平移，不能缩放。sss
                        //     show: true,
                        //     xAxisIndex: [0],
                        //     left: '9%',
                        //     bottom: -5,
                        //     start: 0,
                        //     end: 80 //初始化滚动条
                        // }
                    ],
                    grid: {
                        top: '25%',
                        left: '5%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        // data: ['北京', '上海', '天津', '深圳', '南京', '成都', '苏州'],
                        data: self.insertDeviceAreaList,
                        axisLabel: {
                            color: '#FFFFFF',
                            fontSize: 11
                            // interval: 0,
                            // rotate: 40
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#FFFFFF'
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#66C6E7', // 颜色
                                width: 1, // 粗细
                                opacity: 0.2,
                            }
                        },
                    },

                    series: [
                        {
                            // data: [120, 200, 150, 80, 70, 110, 130],
                            data: self.insertDeviceNumList,
                            type: 'bar',
                            showBackground: false,
                            backgroundStyle: {
                                color: 'rgba(220, 220, 220, 0.8)'
                            },
                            barWidth: '20%',
                            itemStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#5682fd'
                                }, {
                                    offset: 1,
                                    color: '#00013b'
                                }]),
                                // shadowColor: 'rgba(35,55,139, 0.5)',
                                shadowColor: '#23378b',
                                shadowBlur: 0,
                                shadowOffsetX: -4,
                                shadowOffsetY: -2,

                                // borderWidth: 1,
                                // borderColor: '#338484'
                            }
                        }
                    ]
                    // series: [{
                    //     type: 'custom',
                    //     tooltip: {
                    //         backgroundStyle: 'rgba(220, 220, 220, 0.8)'
                    //     },
                    //     itemStyle: {normal: {color: '#5682FD'}},
                    //     renderItem: function (params, api) {
                    //         let location = api.coord([api.value(0), api.value(1)]);
                    //
                    //         // console.log("location", location)
                    //         // console.log("api.value(0)", api.value(0))
                    //         // console.log("api.value(1)", api.value(1))
                    //         return {
                    //             type: 'group',
                    //             children: [{
                    //                 type: 'MyCubeRect',
                    //                 shape: {
                    //                     api,
                    //                     xValue: api.value(0) - insertDeviceXValueOffset,
                    //                     yValue: api.value(1),
                    //                     x: location[0],
                    //                     y: location[1]
                    //                 },
                    //                 style: {
                    //                     fill: '#5682FD'
                    //                 },
                    //             }, {
                    //                 type: 'MyCubeShadow',
                    //                 shape: {
                    //                     api,
                    //                     xValue: api.value(0) - insertDeviceXValueOffset,
                    //                     yValue: api.value(1),
                    //                     x: location[0],
                    //                     y: location[1]
                    //                 },
                    //                 style: {
                    //                     fill: '#5682FD'
                    //                 }
                    //             }]
                    //         };
                    //     },
                    //     data: [],
                    // }]
                },
                productArrange: {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: "#002d69",
                        textStyle: {
                            color: "#2AA7D3",
                            fontWeight: 400,
                        }
                        // borderColor:"rgba(10, 32, 67, 0)",                        //边框颜色
                        // borderWidth:1,
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',      //可设定图例在左、右、居中
                        y: 'top',     //可设定图例在上、下、居中
                        padding: [20, 50, 0, 35],
                        // data: self.yearsList
                        data: [{
                            name: '',
                            textStyle: {
                                color: '#2C80FF'
                            }
                        }, {
                            name: '',
                            textStyle: {
                                color: '#05CDF4'
                            }
                        }
                        ],

                    },
                    grid: {
                        top: '25%',
                        left: '5%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: ['01月', '02月', '03月', '04月', '05月', '06月', '07月', '08月', '09月', '10月', '11月', '12月'],
                        axisLabel: {
                            color: '#5093C1',
                            fontSize: 11
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#5093C1'
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#66C6E7', // 颜色
                                width: 1, // 粗细
                                opacity: 0.2,
                            }
                        }
                    },
                    series: [
                        {
                            name: '',
                            type: 'line',
                            data: [],
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#00013B"},
                                        // {offset: 0.5, color: "rgba(0, 201, 255, 0.3)"},
                                        {offset: 0.8, color: "rgba(0, 201, 255, 0)"}
                                    ])
                                }
                            }, //填充区域样式
                            itemStyle: {
                                normal: {
                                    color: "#2C80FF",//折线点的颜色
                                    lineStyle: {
                                        color: "#2C80FF"//折线的颜色
                                    }
                                }
                            }
                        },
                        {
                            name: '',
                            type: 'line',
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#00013B"},
                                        // {offset: 0.5, color: ""},
                                        {offset: 0.8, color: "rgba(0, 201, 255, 0)"}
                                    ])
                                }
                            }, //填充区域样式
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#05CDF4",//折线点的颜色
                                    lineStyle: {
                                        color: "#05CDF4"//折线的颜色
                                    }
                                }
                            }
                        },
                    ]
                },
                productTypeSpread: {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'right',      //可设定图例在左、右、居中
                        y: 'top',     //可设定图例在上、下、居中
                        padding: [48, 80, 0, 0],
                        align: 'left',
                        icon: 'circle',
                        // data: ["产品1", "产品2", "产品3", "产品4", "产品5"],
                        data: [],
                        textStyle: {
                            color: '#FFFFFF'
                        },
                        // 使用回调函数
                        formatter: function (name) {
                            let lists = [];
                            let inum = target.get(name) / total * 100;
                            //保留inum小数点后２位
                            let vnum = parseFloat(inum).toFixed(2);
                            lists.push(name + '    ' + vnum + '%');
                            return lists;
                        },
                    },
                    grid: {
                        left: 0
                    },
                    graphic: {       //图形中间文字
                        type: "text",
                        left: "22%",
                        top: "center",
                        style: {
                            text: "产品类型",
                            textAlign: "center",
                            fill: "#fff",
                            fontSize: 20,
                            fontWeight: 'bold',
                            color: '#AADDFF',
                            fontFamily: 'Adobe Heiti Std'
                        }
                    },
                    series: [
                        {
                            name: '产品类型',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            center: ['30%', '50%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: false,
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            // data: [
                            //     {value: 335, name: '产品1', itemStyle: {color: '#02B4D2'}},
                            //     {value: 310, name: '产品2', itemStyle: {color: '#FFB608'}},
                            //     {value: 234, name: '产品3', itemStyle: {color: '#9802FE'}},
                            //     {value: 135, name: '产品4', itemStyle: {color: '#00BE8E'}},
                            //     {value: 1548, name: '产品5', itemStyle: {color: '#103EE6'}}
                            // ]
                            data: []
                            // data: self.productTypeSpreadList
                        }
                    ]
                },
                insertCourt: {
                    title: {
                        text: '',
                        subtext: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    dataZoom: [
                        {
                            type: 'inside',
                            yAxisIndex: [0],
                            zoomLock: true,
                            startValue: 0,
                            endValue: 0,
                            orient: 'vertical'
                        }
                    ],
                    legend: {
                        itemHeight: 10,
                        itemWidth: 16,
                        x: 'right',      //可设定图例在左、右、居中
                        y: 'top',     //可设定图例在上、下、居中
                        padding: [20, 70, 0, 0],
                        data: [{
                            name: '已接入',
                            textStyle: {
                                color: '#00F6FF'
                            }
                        }, {
                            name: '未接入',
                            textStyle: {
                                color: '#004EFF'
                            }
                        }],
                        icon: 'rect',
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        boundaryGap: [0, 0.01],
                        axisLabel: {
                            color: '#5ABAF2'
                        },
                        splitLine: {
                            show: false
                        },
                    },
                    yAxis: {
                        type: 'category',
                        data: [],
                        axisLabel: {
                            color: '#5ABAF2',
                            fontSize: 11,
                            // interval: 0,
                            // rotate: 40
                        },
                        splitLine: {
                            show: false
                        },
                    },
                    series: [
                        {
                            name: '已接入',
                            type: 'bar',
                            data: [],
                            barWidth: '20%',
                            itemStyle: {
                                normal: {
                                    color: "#00F6FF",//折线点的颜色
                                    lineStyle: {
                                        color: "#00F6FF"//折线的颜色
                                    }
                                }
                            }
                        },
                        {
                            name: '未接入',
                            type: 'bar',
                            data: [],
                            barWidth: '20%',
                            itemStyle: {
                                normal: {
                                    color: "#004EFF",//折线点的颜色
                                    lineStyle: {
                                        color: "#004EFF"//折线的颜色
                                    }
                                }
                            }
                        }
                    ]
                },
                totalTurnover: {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        // orient: 'vertical',
                        x: 'right',      //可设定图例在左、右、居中
                        y: 'top',     //可设定图例在上、下、居中
                        padding: [20, 70, 0, 0],
                        // data: ['类型1', '类型2'],
                        data: [{
                            name: '',
                            textStyle: {
                                color: '#F9AF1A'
                            }
                        }, {
                            name: '',
                            textStyle: {
                                color: '#40DEFF'
                            }
                        }],
                        icon: 'circle',
                    },
                    grid: {
                        top: '15%',
                        left: '5%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: ['01月', '02月', '03月', '04月', '05月', '06月', '07月', '08月', '09月', '10月', '11月', '12月'],
                        axisLabel: {
                            color: '#FFFFFF',
                            fontSize: 11
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            color: '#FFFFFF'
                        }
                    },
                    series: [
                        {
                            name: '',
                            type: 'line',
                            symbol: 'none',
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#F9AF1A",//折线点的颜色
                                    lineStyle: {
                                        color: "#F9AF1A"//折线的颜色
                                    }
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#00013B"},
                                        // {offset: 0.5, color: "rgba(0, 201, 255, 0.3)"},
                                        {offset: 0.8, color: "rgba(249, 175, 26, 0.01)"}
                                    ])
                                }
                            }, //填充区域样式
                        },
                        {
                            name: '',
                            type: 'line',
                            symbol: 'none',
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: "#40DEFF",//折线点的颜色
                                    lineStyle: {
                                        color: "#40DEFF"//折线的颜色
                                    }
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                        {offset: 0, color: "#00013B"},
                                        // {offset: 0.5, color: "rgba(0, 201, 255, 0.3)"},
                                        {offset: 0.8, color: "rgba(0, 201, 255, 0)"}
                                    ])
                                }
                            }, //填充区域样式
                        },
                    ]
                },
                reverseYearsList: [],
                provinceList: [],
                insertCourtList: [],
                deployedDeviceList: [],
                echartsMap: {
                    title: {
                        text: '',
                        subtext: '',
                        left: ''
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            // let length = JSON.stringify(params.value).split(',')[2].length
                            // let value = JSON.stringify(params.value).split(',')[2].substring(0, length - 1)
                            if (params.name != "" && params.value) {
                                let result = params.name + '<br/>部署产品总量：' + params.value
                                return result
                            }
                        },
                        // backgroundColor: "#002d69",
                        // textStyle: {
                        //     color: "#2AA7D3",
                        //     fontWeight: 400,
                        // }
                    },
                    legend: {
                        data: []
                    },
                    visualMap: {
                        show: false,
                        min: 0,
                        max: 171,
                        text: ['高', '低'],
                        calculable: true,
                        inRange: {
                            // color: ['#044f69', '#06cac7']
                            color: ['#79cefd']
                        },
                        textStyle: {
                            color: '#FFFFFF'
                        },
                        seriesIndex: 1
                    },
                    geo: [{
                        show: true,
                        roam: false,
                        scaleLimit: {
                            min: 0.7,
                            // max: 1
                        },
                        map: 'china',
                        layoutCenter: ['50%', '58%'],
                        layoutSize: 650,
                        label: {
                            normal: {
                                show: false,
                                textStyle: {
                                    color: '#E2F71E',
                                    fontSize: 13
                                }
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                areaColor: 'rgba(20,151,237, 0.7)',
                                borderColor: 'rgba(0,255,255, 0.5)'
                            },
                            emphasis: {
                                areaColor: '#1bb6df'
                            },
                        },
                        zoom: 1.2
                    }],
                    series: [
                        {
                            name: '部署产品总量', // series名称
                            type: 'effectScatter', // series图表类型
                            coordinateSystem: 'geo', // series坐标系类型
                            rippleEffect: {
                                brushType: 'stroke'
                            },
                            symbolSize: 11,
                            tooltip: {
                                show: false
                            },
                            data: []
                        },
                        {
                            type: 'map',  // 类型为地图
                            map: 'china',
                            geoIndex: 0,
                            data: [
                                // {name: '江苏', value: 9999}
                            ]
                        }
                    ]
                },
            }
        },
        mounted() {
            let self = this
            self.getInsertDevice()
            self.initMap()
            self.getInsertCourt()

            target = new Map();
            total = 0;
            self.fullScreenReload()
            self.getProductTypeSpread()
            self.getArrangeAreaNumber()
            self.getTotalTurnover()
            self.getProductArrange()
            self.getReverseNumbers()
            self.getTodayReverseExceptionNumber()
            self.getDealEventNumber()
            self.getAllException()

            setInterval(function () {
                clearInterval(self.insertDeviceInterval)
                clearInterval(self.insertCourtInterval)
                self.getInsertDevice()
                self.initMap()
                self.getInsertCourt()

                target = new Map();
                total = 0;
                self.getProductTypeSpread()
                self.getArrangeAreaNumber()
                self.getTotalTurnover()
                self.getProductArrange()
                self.getReverseNumbers()
                self.getTodayReverseExceptionNumber()
                self.getDealEventNumber()
                self.getAllException()
            }, 1000 * 60 * 15)


            // 暂时去掉
            // setInterval(function () {
            //     let date = new Date()
            //     self.currentDate = self.formatCurrentDate(date)
            //     self.currentYear = self.formatCurrentYear(date)
            //     self.currentWeek = self.formatCurrentWeek(date)
            // }, 1000)


        },
        methods: {
            // 全屏切换刷新
            fullScreenReload() {
                var self = this
                window.onresize = function () {
                    var isFull = window.innerHeight == 1080 && window.innerWidth == 1920
                    if (isFull) {
                        self.$router.go(0)
                    }
                }
            },

            formatCurrentDate(date) {
                date = new Date(date);
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                var d = date.getDate();
                var h = date.getHours();
                var m1 = date.getMinutes();
                var s = date.getSeconds();
                m = m < 10 ? ("0" + m) : m;
                d = d < 10 ? ("0" + d) : d;
                h = h < 10 ? ("0" + h) : h;
                m1 = m1 < 10 ? ("0" + m1) : m1;
                s = s < 10 ? ("0" + s) : s;
                var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
                var day = date.getDay();
                var week = weeks[day];
                return h + ":" + m1 + ":" + s;
            },

            formatCurrentYear(date) {
                date = new Date(date);
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                var d = date.getDate();
                var h = date.getHours();
                var m1 = date.getMinutes();
                var s = date.getSeconds();
                m = m < 10 ? ("0" + m) : m;
                d = d < 10 ? ("0" + d) : d;
                h = h < 10 ? ("0" + h) : h;
                m1 = m1 < 10 ? ("0" + m1) : m1;
                s = s < 10 ? ("0" + s) : s;
                return y + "-" + m + "-" + d;
            },

            formatCurrentWeek(date) {
                var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
                var day = date.getDay();
                var week = weeks[day];
                return week;
            },

            /**
             *  日期转换
             */
            formatDate(date) {
                date = new Date(date);
                var y = date.getFullYear();
                var m = date.getMonth() + 1;
                var d = date.getDate();
                var h = date.getHours();
                var m1 = date.getMinutes();
                var s = date.getSeconds();
                m = m < 10 ? ("0" + m) : m;
                d = d < 10 ? ("0" + d) : d;
                h = h < 10 ? ("0" + h) : h;
                m1 = m1 < 10 ? ("0" + m1) : m1;
                s = s < 10 ? ("0" + s) : s;
                return y + "-" + m + "-" + d + " " + h + ":" + m1 + ":" + s;
            },

            // 重置地图大小和位置
            reSet() {
                let self = this
                $("#reSet").css("display", "none")
                $("#reSetClick").css("display", "block")
                let myChart = echarts.init(document.getElementById('map'))
                myChart.getOption().geo[0].zoom = 1.2
                myChart.getOption().geo[0].layoutCenter = ['50%', '58%']
                myChart.setOption(self.echartsMap, true)
                setTimeout(function () {
                    $("#reSet").css("display", "block")
                    $("#reSetClick").css("display", "none")
                }, 200)
            },

            // 产品使用趋势
            getTotalTurnover() {
                let self = this
                self.reverseYearsList = []
                let myChart = echarts.init(document.getElementById('total_turnover'))

                selectReverseYears().then(data => {

                    data.result.forEach(item => {
                        self.reverseYearsList.push(item + "年")
                    })
                    console.log(self.reverseYearsList)

                    // 只获取近两年
                    self.totalTurnover.legend.data[0].name = self.reverseYearsList[0]
                    self.totalTurnover.legend.data[1].name = self.reverseYearsList[1]

                    self.totalTurnover.series[0].name = self.reverseYearsList[0]
                    self.totalTurnover.series[1].name = self.reverseYearsList[1]

                    selectTotalTurnover().then(data => {
                        let list = Object.keys(data.result)

                        for (let i = 0; i < list.length; i++) {
                            self.totalTurnover.series[i].data = Object.values(data.result)[i]
                        }

                        // 绘制图表
                        myChart.setOption(self.totalTurnover, true);
                    })
                    console.log("self.totalTurnover", self.totalTurnover)

                })


            },

            // 接入法院
            getInsertCourt() {
                let self = this
                self.provinceList = []
                self.insertCourtList = []
                selectInsertCourt().then(data => {
                    data.result.forEach(item => {
                        self.provinceList.push(item.areaName)
                        self.insertCourtList.push(item.total)
                    })
                    let myChart = echarts.init(document.getElementById('insert_court'))
                    self.insertCourt.yAxis.data = self.provinceList
                    self.insertCourt.dataZoom[0].endValue = self.insertCourtList.length - 1;
                    self.insertCourt.dataZoom[0].startValue = self.insertCourtList.length - 12;
                    console.log("provinceList", self.provinceList)
                    console.log("insertCourtList", self.insertCourtList)
                    self.insertCourt.series[0].data = self.insertCourtList
                    let map = new Map()
                    for (let i = 0; i < self.provinceList.length; i++) {
                        map.set(self.provinceList[i], courtMap.courtMap[self.provinceList[i]])
                    }

                    console.log("map", map)
                    for (let i = 0; i < self.provinceList.length; i++) {
                        map.forEach(function (value, key) {
                            if (self.provinceList[i] == key) {
                                self.insertCourt.series[1].data.push(value - self.insertCourtList[i])
                            }
                        })
                    }

                    self.insertCourt.dataZoom[0].endValue = self.insertCourtList.length - 1;
                    self.insertCourt.dataZoom[0].startValue = self.insertCourtList.length - 12;

                    myChart.hideLoading();//滑动条需要的，
                    // 绘制图表
                    myChart.setOption(self.insertCourt, true);

                    // 定时器
                    self.insertCourtInterval = setInterval(function () {
                        // 每次向后滚动一个，最后一个从头开始。
                        if (self.insertCourt.dataZoom[0].startValue == 0) {
                            self.insertCourt.dataZoom[0].endValue = self.insertCourtList.length - 1;
                            self.insertCourt.dataZoom[0].startValue = self.insertCourtList.length - 12;
                        } else {
                            self.insertCourt.dataZoom[0].endValue = self.insertCourt.dataZoom[0].endValue - 1;
                            self.insertCourt.dataZoom[0].startValue = self.insertCourt.dataZoom[0].startValue - 1;
                        }
                        myChart.setOption(self.insertCourt, true);
                    }, 5000);
                })

            },

            // 初始化地图
            initMap() {
                let self = this
                self.deployedDeviceList = []
                // 初始化数据
                self.echartsMap.series[0].data = []
                self.echartsMap.series[1].data = []
                let myChart = echarts.init(document.getElementById('map'))
                // 部署产品总量
                selectdeployedDevicesTotalNumber().then(data => {
                    self.deployedDeviceList = data.result

                    self.deployedDeviceList.forEach(item => {
                        let deployedDevice = {
                            name: '',
                            value: [],
                            label: {show: true, fontSize: 13, color: '#E2F71E', position: 'right', formatter: '{b}'},
                            itemStyle: {color: '#E2F71E'}
                        }
                        deployedDevice.name = item.areaName
                        deployedDevice.value.push(item.longitude)
                        deployedDevice.value.push(item.latitude)
                        deployedDevice.value.push(0)
                        self.echartsMap.series[0].data.push(deployedDevice)

                        let mapData = {
                            name: '', value: 0
                        }
                        mapData.name = item.areaName
                        mapData.value = item.total
                        self.echartsMap.series[1].data.push(mapData)
                    })

                    console.log("self.deployedDeviceList", self.deployedDeviceList)
                    self.echartsMap.series[0].data.forEach(item => {
                        self.deployedDeviceList.forEach(deployedDevice => {
                            if (deployedDevice.areaName == item.name) {
                                console.log(item.name)
                                item.value[2] = deployedDevice.total
                            }
                        })
                    })
                    // 绘制图表
                    // myChart.on('mouseup',function(params){
                    //     self.echartsMap.series[0].data[params.dataIndex].xAxisIndex=params.event.offsetX;
                    //     self.echartsMap.series[0].data[params.dataIndex].yAxisIndex=params.event.offsetY;
                    //     self.echartsMap.series[0].data[params.dataIndex].fixed=true;
                    // });
                    myChart.setOption(self.echartsMap, true)
                    console.log("self.echartsMap", self.echartsMap)
                })


                // debugger
                // myChart.setOption(self.echartsMap, true)

            },

            // 产品部署趋势
            getProductArrange() {

                let self = this
                self.yearsList = []
                selectAllYears().then(data => {
                    data.result.forEach(item => {
                        self.yearsList.push(item + "年")
                    })
                    // 只获取近两年
                    self.productArrange.legend.data[0].name = self.yearsList[0]
                    self.productArrange.legend.data[1].name = self.yearsList[1]

                    self.productArrange.series[0].name = self.yearsList[0]
                    self.productArrange.series[1].name = self.yearsList[1]
                    // console.log(self.yearsList)

                    let myChart = echarts.init(document.getElementById('product_arrange'))

                    selectProductArrange().then(data => {
                        let list = Object.keys(data.result)

                        for (let i = 0; i < list.length; i++) {
                            self.productArrange.series[i].data = Object.values(data.result)[i]
                        }

                        // 绘制图表
                        myChart.setOption(self.productArrange, true)
                    })
                })
            },

            // 产品部署分布
            getInsertDevice() {
                let self = this
                self.insertDeviceAreaList = []
                self.insertDeviceNumList = []


                // var MyCubeRect = echarts.graphic.extendShape({
                //     shape: {
                //         x: 0,
                //         y: 0,
                //         width: 15, //柱宽
                //         zWidth: 8, //阴影折角宽
                //         zHeight: 4, //阴影折角高
                //     },
                //     buildPath: function (ctx, shape) {
                //         const api = shape.api;
                //         const xAxisPoint = api.coord([shape.xValue, 0]);
                //         const p0 = [shape.x, shape.y];
                //         const p1 = [shape.x - shape.width / 2, shape.y];
                //         const p4 = [shape.x + shape.width / 2, shape.y];
                //         const p2 = [xAxisPoint[0] - shape.width / 2, xAxisPoint[1]];
                //         const p3 = [xAxisPoint[0] + shape.width / 2, xAxisPoint[1]];
                //
                //         ctx.moveTo(p0[0], p0[1]); //0
                //         ctx.lineTo(p1[0], p1[1]); //1
                //         ctx.lineTo(p2[0], p2[1]); //2
                //         ctx.lineTo(p3[0], p3[1]); //3
                //         ctx.lineTo(p4[0], p4[1]); //4
                //         ctx.lineTo(p0[0], p0[1]); //0
                //         ctx.closePath();
                //     }
                // });
                // var MyCubeShadow = echarts.graphic.extendShape({
                //     shape: {
                //         x: 0,
                //         y: 0,
                //         width: 15,
                //         zWidth: 8,
                //         zHeight: 4,
                //     },
                //     buildPath: function (ctx, shape) {
                //         const api = shape.api;
                //         const xAxisPoint = api.coord([shape.xValue, 0]);
                //         const p0 = [shape.x, shape.y];
                //         const p1 = [shape.x - shape.width / 2, shape.y];
                //         const p4 = [shape.x + shape.width / 2, shape.y];
                //         const p6 = [shape.x + shape.width / 2 + shape.zWidth, shape.y - shape.zHeight];
                //         const p7 = [shape.x - shape.width / 2 + shape.zWidth, shape.y - shape.zHeight];
                //         const p3 = [xAxisPoint[0] + shape.width / 2, xAxisPoint[1]];
                //         const p5 = [xAxisPoint[0] + shape.width / 2 + shape.zWidth, xAxisPoint[1] - shape.zHeight];
                //
                //         ctx.moveTo(p4[0], p4[1]); //4
                //         ctx.lineTo(p3[0], p3[1]); //3
                //         ctx.lineTo(p5[0], p5[1]); //5
                //         ctx.lineTo(p6[0], p6[1]); //6
                //         ctx.lineTo(p4[0], p4[1]); //4
                //
                //         ctx.moveTo(p4[0], p4[1]); //4
                //         ctx.lineTo(p6[0], p6[1]); //6
                //         ctx.lineTo(p7[0], p7[1]); //7
                //         ctx.lineTo(p1[0], p1[1]); //1
                //         ctx.lineTo(p4[0], p4[1]); //4
                //         ctx.closePath();
                //     }
                // });
                //
                // echarts.graphic.registerShape('MyCubeRect', MyCubeRect);
                // echarts.graphic.registerShape('MyCubeShadow', MyCubeShadow);

                selectInsertDevice().then(data => {
                    data.result.forEach(item => {
                        self.insertDeviceAreaList.push(item.areaName)
                        self.insertDeviceNumList.push(item.total)
                    })
                    let myChart = echarts.init(document.getElementById('insert_device'))
                    self.insertDevice.series[0].data = self.insertDeviceNumList
                    self.insertDevice.xAxis.data = self.insertDeviceAreaList

                    self.insertDevice.dataZoom[0].endValue = 8;
                    self.insertDevice.dataZoom[0].startValue = 0;

                    myChart.hideLoading();//滑动条需要的，
                    // 绘制图表
                    myChart.setOption(self.insertDevice, true);

                    // 定时器
                    self.insertDeviceInterval = setInterval(function () {
                        // 每次向后滚动一个，最后一个从头开始。
                        if (self.insertDevice.dataZoom[0].endValue == self.insertDeviceNumList.length - 1) {
                            self.insertDevice.dataZoom[0].endValue = 8;
                            self.insertDevice.dataZoom[0].startValue = 0;
                        } else {
                            self.insertDevice.dataZoom[0].endValue = self.insertDevice.dataZoom[0].endValue + 1;
                            self.insertDevice.dataZoom[0].startValue = self.insertDevice.dataZoom[0].startValue + 1;
                        }
                        console.log("startValue", self.insertDevice.dataZoom[0].startValue)
                        console.log("endValue", self.insertDevice.dataZoom[0].endValue)
                        myChart.setOption(self.insertDevice, true);
                    }, 5000);
                })
            },

            // 产品类型分布
            getProductTypeSpread() {
                let self = this
                self.productTypeNameList = []
                self.productTypeSpreadList = []
                selectProductTypeSpread().then(data => {
                    let productTypeList = data.result
                    let productTypeDataList = productTypeList
                    let totalNum = 0
                    let productNum = 0
                    if (productTypeList.length > 7) {
                        productTypeDataList = []
                        productTypeList.forEach(item => {
                            totalNum += item.total
                        })
                        for (let i = 0; i < 7; i++) {
                            productNum += productTypeList[i].total
                            productTypeDataList.push(productTypeList[i])
                        }
                        console.log(totalNum + '-----' + productNum)

                    }
                    productTypeDataList.forEach(item => {
                        self.productTypeData = {
                            value: '',
                            name: '',
                            itemStyle: {
                                color: ''
                            }
                        }
                        self.productTypeNameList.push(item.productName)
                        self.productTypeData.value = item.total
                        self.productTypeData.name = item.productName
                        // 产品添加颜色
                        if (self.productTypeData.name == '云柜') {
                            self.productTypeData.itemStyle.color = '#01B4D2'
                        } else if (self.productTypeData.name == '中间柜') {
                            self.productTypeData.itemStyle.color = '#FFB508'
                        } else if (self.productTypeData.name == '易诉柜') {
                            self.productTypeData.itemStyle.color = '#9702FE'
                        } else if (self.productTypeData.name == '记名柜') {
                            self.productTypeData.itemStyle.color = '#00BD8D'
                        } else if (self.productTypeData.name == '送达柜') {
                            self.productTypeData.itemStyle.color = '#00F6FF'
                        } else if (self.productTypeData.name == '虚拟柜') {
                            self.productTypeData.itemStyle.color = '#EF2051'
                        } else if (self.productTypeData.name == '交转柜') {
                            self.productTypeData.itemStyle.color = '#FCE38A'
                        } else if (self.productTypeData.name == '其他') {
                            self.productTypeData.itemStyle.color = '#258FFF'
                        }
                        self.productTypeSpreadList.push(self.productTypeData)
                    })

                    if (productTypeList.length > 7) {
                        self.productTypeData = {
                            value: '',
                            name: '',
                            itemStyle: {
                                color: ''
                            }
                        }
                        self.productTypeNameList.push('其他')

                        self.productTypeData.value = totalNum - productNum
                        self.productTypeData.name = '其他'
                        self.productTypeSpreadList.push(self.productTypeData)
                    }
                    console.log("self.productTypeNameList", self.productTypeNameList)
                    console.log("self.productTypeSpreadList", self.productTypeSpreadList)

                    // 产品类型分布的百分比
                    let mdataList = self.productTypeSpreadList
                    mdataList.forEach((item) => {
                        // 计算value的和，用来算百分比
                        total += item.value
                        // 组成 map {A:1212} ,用来下面获取 value
                        target.set(item.name, item.value)
                    })

                    let myChart = echarts.init(document.getElementById('product_type'))
                    self.productTypeSpread.legend.data = self.productTypeNameList
                    self.productTypeSpread.series[0].data = self.productTypeSpreadList
                    // 绘制图表
                    myChart.setOption(self.productTypeSpread, true);
                })
            },

            // 累计部署量
            getArrangeAreaNumber() {
                let self = this
                selectArrangeAreaNumber().then(data => {
                    self.past_arrange_area_number = self.arrangeAreaNumber
                    self.arrangeAreaNumber = data.result
                })
            },

            // 计算总设备的流转量
            getReverseNumbers() {
                let self = this
                selectReverseNumbers().then(data => {
                    self.past_reverse_numbers = self.reverseNumbers
                    self.reverseNumbers = data.result
                    // console.log(self.reverseNumbers / (1000 * 100))
                    // if (self.reverseNumbers / (1000 * 100) > 10) {
                    //     $(".volume_statistics").css("left", "535px")
                    //     $(".arrange_area").css("width", "180px")
                    //     $(".device_roam").css("width", "220px")
                    //     $(".today_exception").css("width", "180px")
                    //     $(".deal_event").css("width", "180px")
                    // }
                })
            },

            // 今日异常数量
            getTodayReverseExceptionNumber() {
                let self = this
                selectTodayReverseExceptionNumber().then(data => {
                    self.past_today_reverse_exception_number = self.todayReverseExceptionNumber
                    self.todayReverseExceptionNumber = data.result
                })
            },

            // 计算总处理事件
            getDealEventNumber() {
                let self = this
                selectDealEventNumber().then(data => {
                    self.past_deal_event_number = self.dealEventNumber
                    self.dealEventNumber = data.result
                })
            },

            // 异常一览
            getAllException() {
                let self = this
                self.exceptionList = []
                selectAllException().then(data => {
                    self.exceptionList = data.result
                    let len = self.exceptionList.length
                    self.exceptionList.forEach(item => {
                        if (item.exceptionTime) {
                            item.exceptionTime = self.formatDate(item.exceptionTime)
                        }
                    })

                    if (self.exceptionList.length < 9 && self.exceptionList.length > 0) {
                        for (let i = len; i < 9; i++) {
                            let data = {
                                productName: '',
                                apiCompanyName: '',
                                exceptionTime: ''
                            }
                            self.exceptionList.push(data)
                        }
                    }
                    console.log("self.exceptionList ", self.exceptionList)
                })
            },

        }
    }
</script>

<style scoped>
    .seamless-warp {
        width: 492px;
        margin-left: 2px;
        overflow: hidden;
        max-height: 232px;
        z-index: 10;
    }

    .container {
        width: 1920px;
        height: 1080px;
        background: #00013B;
        background-image: url("../../../static/images/shade.png"), url("../../../static/images/baseplate.gif"), url("../../../static/images/brighten.png");
        background-repeat: no-repeat;
        /*background-attachment: fixed;*/
        background-position: bottom;
        position: relative;
    }

    .current_date {
        position: absolute;
        right: 300px;
        top: 53px;
        /*width: 63px;*/
        /*height: 22px;*/
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 550;
        color: #00A2FF;
        text-shadow: 1px 5px 5px rgba(0, 26, 110, 0.75);

        background: linear-gradient(0deg, #5197FF 0%, #80F2FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .current_year {
        position: absolute;
        right: 175px;
        top: 53px;
        /*color: white;*/
        /*width: 151px;*/
        /*height: 22px;*/
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 550;
        color: #00A2FF;
        text-shadow: 1px 5px 5px rgba(0, 26, 110, 0.75);

        background: linear-gradient(0deg, #5197FF 0%, #80F2FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .current_week {
        position: absolute;
        right: 109px;
        top: 52px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 550;
        color: #00A2FF;
        text-shadow: 1px 5px 5px rgba(0, 26, 110, 0.75);

        background: linear-gradient(0deg, #5197FF 0%, #80F2FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .bi_title {
        width: 424px;
        height: 39px;
        font-size: 40px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 30px;
        margin: 0 auto;
        padding-top: 22px;
    }

    .bi_product {
        width: 492px;
        height: 40px;
        /*background: linear-gradient(92deg, #0826B7, #01B5FF);*/
        /*opacity: 0.7;*/
        background-image: url('../../../static/images/title_bg.png');
        margin-left: 15px;
        margin-top: 19px;
    }

    .bi_product_add {
        width: 132px;
        height: 40px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 41px;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_device {
        width: 492px;
        height: 40px;
        background-image: url('../../../static/images/title_bg.png');
        margin-left: 15px;
        margin-top: 5px;
    }

    .bi_insert_device {
        width: 132px;
        height: 40px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 41px;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_data {
        width: 492px;
        height: 40px;
        background-image: url('../../../static/images/title_bg.png');
        margin-left: 15px;
        margin-top: 5px;
    }

    .bi_court {
        width: 492px;
        height: 40px;
        background-image: url('../../../static/images/title_bg.png');
        margin-top: 19px;
    }

    .bi_insert_court {
        width: 132px;
        height: 40px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 41px;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_product_type {
        width: 492px;
        height: 40px;
        background-image: url('../../../static/images/title_bg.png');
        margin-top: 5px;
    }

    .bi_exception {
        width: 492px;
        height: 40px;
        background-image: url('../../../static/images/title_bg.png');
        margin-top: 5px;
    }

    .bi_product_type_distribute {
        width: 132px;
        height: 40px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 41px;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_exception_show {
        width: 132px;
        height: 40px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 41px;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    .bi_data_type {
        width: 132px;
        height: 40px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 550;
        color: #2AA8D3;
        line-height: 41px;
        background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);
        -webkit-background-clip: text;
        margin-left: 18px;
        -webkit-text-fill-color: transparent;
    }

    /*.volume_statistics {*/
    /*    width: 112px;*/
    /*    height: 35px;*/
    /*    font-size: 28px;*/
    /*    font-family: Source Han Sans CN;*/
    /*    font-weight: 550;*/
    /*    color: #2AA8D3;*/
    /*    !*line-height: 91px;*!*/
    /*    background: linear-gradient(92deg, #0073FF 0%, #00EBFF 48.8525390625%, #02AAFF 100%);*/
    /*    -webkit-background-clip: text;*/
    /*    -webkit-text-fill-color: transparent;*/
    /*    margin: 0 auto;*/
    /*    margin-top: 27px;*/
    /*}*/

    .arrange_area {
        width: 200px;
        height: 92px;
        /*background: rgba(10, 32, 68, 0.2);*/
        /*border: 2px solid rgba(55, 86, 218, 0.3);*/
        background-image: url('../../../static/images/data_bg.png');
        margin-top: 40px;
        background-size: cover;
    }

    .device_roam {
        width: 200px;
        height: 92px;
        background-image: url('../../../static/images/data_bg.png');
        margin-top: 40px;
        background-size: cover;
    }

    .today_exception {
        width: 200px;
        height: 92px;
        background-image: url('../../../static/images/data_bg.png');
        margin-top: 40px;
        background-size: cover;
    }

    .deal_event {
        width: 200px;
        height: 92px;
        background-image: url('../../../static/images/data_bg.png');
        margin-top: 40px;
        background-size: cover;
    }

    .arrange_area_number {
        /*width: 56px;*/
        height: 25px;
        font-size: 34px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #08C8F1;
        margin: 15px auto 0;
        text-align: center;
    }

    .device_roam_number {
        /*width: 93px;*/
        height: 25px;
        font-size: 34px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFB027;
        margin: 15px auto 0;
        text-align: center;
    }

    .today_exception_number {
        /*width: 112px;*/
        height: 25px;
        font-size: 34px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FF3300;
        margin: 15px auto 0;
        text-align: center;
    }

    .deal_event_number {
        /*width: 75px;*/
        height: 25px;
        font-size: 34px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #00CC00;
        margin: 15px auto 0;
        text-align: center;
    }

    .arrange_area_text {
        width: 91px;
        height: 18px;
        font-size: 18px;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Arial, sans-serif;
        font-weight: 400;
        color: #08C8F2;
        margin: 15px auto 0;
    }

    .device_roam_text {
        width: 110px;
        height: 18px;
        font-size: 18px;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Arial, sans-serif;
        font-weight: 400;
        color: #FFB027;
        margin: 15px auto 0;
    }

    .today_exception_text {
        width: 100px;
        height: 18px;
        font-size: 18px;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Arial, sans-serif;
        font-weight: 400;
        color: #FF3300;
        margin: 15px auto 0;
    }

    .deal_event_text {
        /*width: 110px;*/
        height: 18px;
        font-size: 18px;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Arial, sans-serif;
        font-weight: 400;
        color: #00CC00;
        margin: 15px auto 0;
    }

    .exception_title {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FEE614;
        flex: 1;
    }

    .exception_content {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        flex: 1;
    }

    .reSet {
        width: 38px;
        height: 38px;
        position: absolute;
        top: 300px;
        left: 550px;
        z-index: 10;
    }
</style>



// WEBPACK FOOTER //
// src/view/bi/index.vue